import { render, staticRenderFns } from "./ViewBuildings.vue?vue&type=template&id=19deea92"
import script from "./ViewBuildings.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBuildings.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports